const LogoutClient = {
  logoutURL: "logout",
};

export default LogoutClient;
